module.exports = "<input type=\"text\" (change)=\"emit()\" [id]=\"element\" [ngClass]=\"{'is-invalid':error}\" class=\"form-control date\"\r\n[readonly]=\"readonly\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/datepicker/datepicker.component.html
// module id = ./src/app/components/tools/datepicker/datepicker.component.html
// module chunks = main